
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rabattkoder/nytelse",
      function () {
        return require("private-next-pages/rabattkoder/nytelse.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rabattkoder/nytelse"])
      });
    }
  